import { render, staticRenderFns } from "./employee-shifts.vue?vue&type=template&id=6b0585e9&"
import script from "./employee-shifts.vue?vue&type=script&lang=js&"
export * from "./employee-shifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "employee-shifts.vue"
export default component.exports